import React from 'react';
import { Switch } from 'antd';
import { 
    BugOutlined,
    ProjectOutlined,
    StopOutlined,
    TeamOutlined,
    UnorderedListOutlined,
    SwapOutlined,
    StarOutlined,
} from '@ant-design/icons';
import { SettingsModuleRow } from '@/pages/inside/tenant/style';
import { colors } from '@/utils/colorSystem';

const ICON_MAP = {
    BugOutlined: <BugOutlined />,
    ProjectOutlined: <ProjectOutlined />,
    StopOutlined: <StopOutlined />,
    TeamOutlined: <TeamOutlined />,
    UnorderedListOutlined: <UnorderedListOutlined />,
    SwapOutlined: <SwapOutlined />,
    StarOutlined: <StarOutlined />,
};

export default function ModuleToggleControl({ checked, onChange, mod, disabled }) {
    const iconElement = ICON_MAP[mod.iconName] || mod.icon || null;

    return (
        <SettingsModuleRow>
            <div className="toggle-icon" style={{ background: checked ? mod.bgColor : colors.neutral[50], color: checked ? mod.color : colors.neutral[300] }}>
                {iconElement}
            </div>
            <div className="toggle-content">
                <div className="toggle-label">{mod.label}</div>
                <div className="toggle-desc">{mod.description}</div>
            </div>
            <Switch 
                size="small" 
                checked={checked} 
                onChange={onChange} 
                disabled={disabled}
            />
        </SettingsModuleRow>
    );
}
